import { useForm } from '@mantine/form';
import Form from './form';
import { isPassword, isUserName } from '../../helpers/common';
import { useNavigate, useParams } from 'react-router-dom'; 
import {LoginUser} from '../../store/actions';
// import loginUserviaapi from '@/store/auth/login/saga'; 
import { useDispatch} from "react-redux";
const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const form = useForm({
    initialValues: {
      userName: "",
      password: ''
    },
    validate: {
      userName: (val: any) => (isUserName(val)),
      password: (val: any) => (isPassword(val))
    },
  });
  
  const submitLogin = (e:any) => {
    e.preventDefault();
    form.validate();
    if (form.isValid()) {
      dispatch(LoginUser(form.values,navigate));
    }
  }
  return (
    <Form formData={form} submitLogin={submitLogin}/>
  );
};

export default Login;

